export class SpecialistVendor {
  public fullName: string;
  public mail: string;
  public phone: string;
}
